import { HomeService } from 'app/main/admin/home/home.service';
import { Component, Input, OnInit } from "@angular/core";
import { Chart } from "chart.js";
import { TotalVisualizacoesMensais } from 'app/shared/models/home/views';
@Component({
  selector: "app-stacked-bars-app-grafic",
  templateUrl: "./stacked-bars-app-grafic.component.html",
  styleUrls: ["./stacked-bars-app-grafic.component.scss"],
})
export class StackedBarsAppGraficComponent implements OnInit {
  chart;
  color = "#70AD47";
  //custom type
  responseViews:any;
  dados : Array <TotalVisualizacoesMensais> =[];
  
  constructor(private homeService : HomeService) {}
  ngOnInit(){
    this.methodGraficos();
  }

  async methodGraficos() {
    // this.responseViews = await this.homeService.getDataViews();
    this.dados = this.responseViews.totalVisualizacoesMensais;
    
    let dataTeste = {
      labels: [],
      datasets: [
        {
          categoryPercentage: 0.5,
          maxBarThickness: 60,
          minBarLength: 60,
          label: "",
          fill: false,
          data: [],
          backgroundColor: [],
          borderColor: [],
        },
      ],
    };
    for (let i of this.dados) {
      dataTeste.labels.push(i.dataVisualizacao);
      dataTeste.datasets[0].data.push(i.totalVisualizacoesPostagensComplienteMensal);
      dataTeste.datasets[0].backgroundColor.push(this.color);
      dataTeste.datasets[0].borderColor.push(this.color);
    }
    this.chart = new Chart("canvas", {
      type: "bar",
      data: dataTeste,
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    });
    this.chart.resize();
  }
}
